var isMobile = window.innerWidth <= 980;

var imagesList = document.querySelectorAll("#main-content img");


for (var tempIndex = 0; tempIndex < imagesList.length; tempIndex++) {
  var tempImage = imagesList[tempIndex];
  if (!tempImage.getAttribute("src")) {
    tempImage.setAttribute(
      "src",
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="
    );
  } 
}



function wapPageInit() {

  //注册图片懒加载
  new LazyLoad({
    elements_selector: "#main-content img",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    threshold: "3000",
    callback_enter: function (element) { },
  });
  
  new LazyLoad({
    elements_selector: "#main-content video",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    data_poster: "cbcn-poster",
    threshold: "3000",
    callback_enter: function (element) { },
  });

  // 移动端横屏问题
  var refreshTimer = null;
  // 或者监听设备方向的变化
  window.addEventListener("orientationchange", () => {
    // let orientation = screen.orientation || window.orientation;
    // if (orientation.type.includes('portrait')) {
    //   // 竖屏
    //   console.log('现在是竖屏');
    // } else if (orientation.type.includes('landscape')) {
    //   // 横屏
    //   console.log('现在是横屏');
    // }

    refreshTimer = this.clearTimeout(refreshTimer);
    setTimeout(ScrollTrigger.refresh, 200);
  });






  // 05 begin

const traydescPanels = document.querySelectorAll('.tray-text-desc[data-desc]');
function trayswitchCaption(index) {
    traydescPanels.forEach(panel => {
        panel.classList.toggle('active', Number(panel.dataset.desc) === index);
    });
}

// 初始化 Swiper - 比较轮播
const trayswiper = new Swiper('.tray-swiper', {

    direction: 'horizontal',
    speed: 800,
    slidesPerView: 1,      
    spaceBetween: 10,  
        
    breakpoints: {
        320: {
            slidesPerView: 1.2,
            spaceBetween: 10,
        },         
        768: {
            slidesPerView: 1,
            spaceBetween: 10
        },
        // When window width is >= 1024px
        1024: {
            slidesPerView: 1,
            spaceBetween: 20
        }
    },     
    on: {
        slideChange: function () {
            // 更新选项卡按钮状态
            traytabButtons.forEach((button, index) => {
                if (index === this.activeIndex) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
            
            // 控制比较轮播中的视频播放
            const comparisonVideos = document.querySelectorAll('.tray-swiper video');
            comparisonVideos.forEach((video, idx) => {
                if (idx === this.activeIndex) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            // 同步 caption
            trayswitchCaption(this.activeIndex);
        },
    }
});

// 获取比较轮播的选项卡按钮
const traytabButtons = document.querySelectorAll('.tray-tab-button');

// 比较轮播选项卡点击事件
traytabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
        // 切换到对应幻灯片
        trayswiper.slideTo(index);
        
        // 更新按钮状态
        traytabButtons.forEach((btn, idx) => {
            if (idx === index) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        // 同步 caption
        trayswitchCaption(index);
    });
});

  // 05 end


  // 07 begin

    new Swiper('.sec07family', {
        direction: 'horizontal',
        speed: 800,
        slidesPerView: 1.2,      
        spaceBetween: 20,  
        
        // 响应式断点
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 1.2,
                spaceBetween: 10
            },
            // When window width is >= 1024px
            1024: {
                slidesPerView: 1,
                spaceBetween: 20
            }
        },

        pagination: {
            el: '.sec10ok',
            clickable: true,
            dynamicBullets: false,
        },

        navigation: {
            nextEl: '.sec07family-next',
            prevEl: '.sec07family-prev',
        },
    });

  // 07 end


  // 09 begin

const motordescPanels = document.querySelectorAll('.motor-text-desc[data-desc]');

function motorswitchCaption(index) {
    motordescPanels.forEach(panel => {
        panel.classList.toggle('active', Number(panel.dataset.desc) === index);
    });
}
// 初始化 
const motorswiper = new Swiper('.motor-swiper', {
    direction: 'horizontal',
    speed: 800,
    slidesPerView: 1,      
    spaceBetween: 20,  
        
    breakpoints: {
        768: {
            slidesPerView: 1,
            spaceBetween: 10
        },
        // When window width is >= 1024px
        1024: {
            slidesPerView: 1,
            spaceBetween: 20
        }
    },          
  
    on: {
        slideChange: function () {
            // 更新选项卡按钮状态
            motortabButtons.forEach((button, index) => {
                if (index === this.activeIndex) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
            
            
            const motorVideos = document.querySelectorAll('.motor-swiper video');
            motorVideos.forEach((video, idx) => {
                if (idx === this.activeIndex) {
                    video.play();
                } else {
                    video.pause();
                }
            });
            // 同步 caption
            motorswitchCaption(this.activeIndex);

        },
    }
});


const motortabButtons = document.querySelectorAll('.motor-tab-button');


motortabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
        // 切换到对应幻灯片
        motorswiper.slideTo(index);
        
        // 更新按钮状态
        motortabButtons.forEach((btn, idx) => {
            if (idx === index) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        // 同步 caption
        motorswitchCaption(index);         
    });
   
});

  // 09 end

  // 10 begin

const cabindescPanels = document.querySelectorAll('.cabin-text-desc[data-desc]');
function switchCaption(index) {
    cabindescPanels.forEach(panel => {
        panel.classList.toggle('active', Number(panel.dataset.desc) === index);
    });
}

const cabinswiper = new Swiper('.cabin-swiper', {

    direction: 'horizontal',
    speed: 800,
    slidesPerView: 1,      
    spaceBetween: 10,  
        
    breakpoints: {
        320: {
            slidesPerView: 1.2,
            spaceBetween: 10
        },        
        768: {
            slidesPerView: 1.2,
            spaceBetween: 10
        },
        // When window width is >= 1024px
        1024: {
            slidesPerView: 1,
            spaceBetween: 20
        }
    },     
    on: {
        slideChange: function () {
            // 更新选项卡按钮状态
            tabButtonsCabin.forEach((button, index) => {
                if (index === this.activeIndex) {
                    button.classList.add('active');
                } else {
                    button.classList.remove('active');
                }
            });
            
            // 控制比较轮播中的视频播放
            const comparisonVideos = document.querySelectorAll('.cabin-swiper video');
            comparisonVideos.forEach((video, idx) => {
                if (idx === this.activeIndex) {
                    video.play();
                } else {
                    video.pause();
                }
            });

            // 同步 caption
            switchCaption(this.activeIndex);
        },
    }
});


const tabButtonsCabin = document.querySelectorAll('.cabin-tab-button');

// 比较轮播选项卡点击事件
tabButtonsCabin.forEach((button, index) => {
    button.addEventListener('click', () => {
        // 切换到对应幻灯片
        cabinswiper.slideTo(index);
        
        // 更新按钮状态
        tabButtonsCabin.forEach((btn, idx) => {
            if (idx === index) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        // 同步 caption
        switchCaption(index);
    });
});

  // 10 end


  // 14 begin

            new Swiper('.s-14', {
                direction: 'horizontal',
                speed: 800,
                spaceBetween: 20,
                slidesPerView: 3,
                
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                    },
                    769: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
                
                navigation: {
                    nextEl: '.sec14-next',
                    prevEl: '.sec14-prev',
                },
            });

  // 14 end


  // 23 begin

            new Swiper('.s23', {
                direction: 'horizontal',
                speed: 800,
                spaceBetween: 10,
                slidesPerView: 4,
                
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                    },
                    769: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                    },
                    1025: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                },
                navigation: {
                    nextEl: '.sec23-next',
                    prevEl: '.sec23-prev',
                },
                        
            });

  // 23 end




}

if (isMobile) {
  window.onload = function () {

    wapPageInit();
  };
}